var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "party-popper") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconen-drukke-dagen",
    transform: "translate(-122.000000, -16.000000)",
    fill: "#FF8100",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "party-popper",
    transform: "translate(122.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.53,0.45 L11.45,1.53 L13.05,3.13 C13.27,3.38 13.38,3.67 13.38,4 C13.38,4.33 13.27,4.64 13.05,4.86 L9.5,8.47 L10.5,9.55 L14.13,5.94 C14.66,5.35 14.92,4.7 14.92,4 C14.92,3.3 14.66,2.64 14.13,2.05 L12.53,0.45 M8.55,2.47 L7.47,3.55 L8.08,4.11 C8.3,4.33 8.41,4.63 8.41,5 C8.41,5.37 8.3,5.67 8.08,5.89 L7.47,6.45 L8.55,7.53 L9.11,6.92 C9.64,6.33 9.91,5.69 9.91,5 C9.91,4.28 9.64,3.63 9.11,3.03 L8.55,2.47 M19,4.06 C18.31,4.06 17.67,4.33 17.08,4.86 L11.45,10.5 L12.53,11.5 L18.11,5.94 C18.36,5.69 18.66,5.56 19,5.56 C19.34,5.56 19.64,5.69 19.89,5.94 L20.5,6.55 L21.53,5.47 L20.97,4.86 C20.38,4.33 19.72,4.06 19,4.06 M5,7 L0,21 L14,16 L5,7 M17,10.06 C16.3,10.06 15.66,10.33 15.06,10.86 L13.47,12.45 L14.55,13.53 L16.14,11.94 C16.39,11.69 16.67,11.56 17,11.56 C17.33,11.56 17.63,11.69 17.88,11.94 L19.5,13.53 L20.55,12.5 L18.95,10.86 C18.36,10.33 17.7,10.06 17,10.06 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.3c45da71cebc7f38cc7bfb5c278e338b.svg";
export { ForwardRef as ReactComponent };